<div class="modal-header">
  <h4 class="modal-title">
    {{ existingOption ? 'Edit' : 'Add' }} Upfront Payment Option
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body pb-0">
  <div class="mb-3">
    <label for="number_of_periods">
      Number of Upfront Periods
    </label>
    <div class="input-group">
      <input type="number"
             step="1" min="2" required
             id="number_of_periods"
             name="number_of_periods"
             class="form-control"
             [(ngModel)]="upfrontPaymentOption.number_of_periods">
      <div class="input-group-append">
        <span class="input-group-text">
          {{ getMembershipIntervalDisplaySingle(membership.interval) }}s
        </span>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <label for="discount_type">
      Discount Type
    </label>
    <select class="custom-select" required
            id="discount_type"
            name="discount_type"
            [(ngModel)]="upfrontPaymentOption.discount_type">
      <option [ngValue]="MembershipDiscountType.currency">
        {{ orgConfig.getCurrencyName() }} amount
      </option>
      <option [ngValue]="MembershipDiscountType.percentage">
        Percentage
      </option>
    </select>
    <small class="form-text text-muted">
      Currency discounts are applied to the total, not per-period. For example, a $100 monthly membership paying for 3 months upfront with a discount amount of $10 would pay a total of $290.
    </small>
  </div>

  <div class="mb-3">
    <label for="discount_amount">
      Discount Amount
    </label>
    <div class="input-group">
      <div class="input-group-prepend"
           *ngIf="upfrontPaymentOption.discount_type === MembershipDiscountType.currency">
        <span class="input-group-text">
          {{ orgConfig.getCurrencySymbol() }}
        </span>
      </div>
      <input type="number"
             step="0.01" min="0.01" required
             id="discount_amount"
             name="discount_amount"
             class="form-control"
             [(ngModel)]="upfrontPaymentOption.discount_amount">
      <div class="input-group-append"
           *ngIf="upfrontPaymentOption.discount_type === MembershipDiscountType.percentage">
        <span class="input-group-text">
          %
        </span>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <div class="form-check">
      <input class="form-check-input" type="checkbox"
             id="enableMinTimeWithoutActiveOrFrozenMembershipDays"
             [(ngModel)]="enableMinTimeWithoutActiveOrFrozenMembershipDays">
      <label class="form-check-label"
             for="enableMinTimeWithoutActiveOrFrozenMembershipDays">
        Only offer to customers who have not had a membership for a certain number of days
      </label>
    </div>
  </div>

  <div class="mb-3 indented-subsection"
       *ngIf="enableMinTimeWithoutActiveOrFrozenMembershipDays">
    <label for="min_time_without_active_or_frozen_membership_days">
      Number of days without an active or frozen membership
    </label>
    <input type="number"
           step="1" required
           id="min_time_without_active_or_frozen_membership_days"
           name="min_time_without_active_or_frozen_membership_days"
           class="form-control"
           [(ngModel)]="upfrontPaymentOption.min_time_without_active_or_frozen_membership_days">
  </div>

  <div class="mb-3">
    <label>
      Dates when this option can be purchased (optional)
    </label>
    <div class="row">
      <div class="col-6">
        <label for="upfrontOptionAvailableStartDateInput">Start Date</label>
        <app-date-picker [id]="'upfrontOptionAvailableStartDateInput'"
                         [(content)]="upfrontPaymentOption.available_start_date"></app-date-picker>
      </div>
      <div class="col-6">
        <label for="upfrontOptionAvailableEndDateInput">End Date</label>
        <app-date-picker [id]="'upfrontOptionAvailableEndDateInput'"
                         [(content)]="upfrontPaymentOption.available_end_date"></app-date-picker>
      </div>
    </div>
    <small class="form-text text-muted">
      This option can only be purchased from the start date through the end date. Leave a date blank for no limit on that side. The dates are compared with the day of purchase, not the membership's start date.
    </small>
  </div>

  <div *ngIf="errorMessage() !== null"
       class="alert alert-danger mb-3">
    {{ errorMessage() }}
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Cancel
  </button>
  <button class="btn btn-primary"
          (click)="handleSubmit()"
          [disabled]="!inputsValid()"
          [class.disabled]="!inputsValid()">
    Submit
  </button>
</div>
